module.exports = __webpack_public_path__ + "img/5.418c23e3.png";